import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { usePartnerForm } from '../../hooks/usePartnerForm';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const TrackingOption2 = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = usePartnerForm();
    const handleChange = (e) => {
        updateFormData(FORM_FIELD_PATHS.TRACKING_OPTION_2, e.target.value);
    };
    const hasError = !!errors?.trackingOption2 && touched?.trackingOption2;
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Tracking Option 2
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NameField}
                        id="trackingOption2"
                        name="trackingOption2"
                        value={
                            formData?.partnerBillingSettings?.trackingOption2 ||
                            ''
                        }
                        onChange={handleChange}
                        placeholder="Tracking Option 2"
                        width="100%"
                        darkMode={darkMode}
                        isInvalid={hasError}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter tracking option 2 for this partner"
                        ariaLabel="trackingoption2-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};
export default TrackingOption2;
